import scrollIntoView from 'smooth-scroll-into-view-if-needed';

import { IS_IFRAME_MODE } from 'config/envVariable';
import * as postMsgEvent from 'config/postMsgEvent';

export function windowScroll({ top = 0, left = 0 } = {}) {
    try {
        window.scroll({
            behavior: 'smooth',
            top,
            left
        });
    } catch {
        window.scroll(top, left);
    }
}

export function scrollPromoBodyIntoView() {
    const promoBody = document.getElementById('promo-client-body');
    if (promoBody) {
        if (IS_IFRAME_MODE) {
            scrollElemIntoViewIframeMode(promoBody);
        } else {
            scrollElementInner(promoBody, { top: 0 });
        }
    }
}

export function scrollElementIntoView(element, block = 'start', { always = false } = {}) {
    if (element) {
        if (IS_IFRAME_MODE) {
            scrollElemIntoViewIframeMode(element, block);
        } else {
            scrollIntoView(element, {
                scrollMode: always ? 'always' : 'if-needed',
                block,
                behavior: 'smooth'
            });
        }
    }
}
function scrollElemIntoViewIframeMode(element, block = 'start') {
    const clientRect = element.getBoundingClientRect();
    const elementTopOffsetWithFrame = clientRect.top;
    window.parent.postMessage(
        {
            event: postMsgEvent.SCROLL_INTO_VIEW,
            payload: { elementTopOffsetWithFrame, block }
        },
        '*'
    );
}

function scrollElementInner(element, { top = 0, left = 0 } = {}) {
    if (typeof element.scroll === 'function') {
        try {
            setTimeout(() => {
                element.scroll({
                    top,
                    left,
                    behavior: 'smooth'
                });
            }, 200);
        } catch {
            element.scroll(left, top);
        }
    }
}
